import React from "react";
import {
    CalendarToday,
    Percent,
    Tag,
    TextFields,
} from "mosaic-react-icons";

const FieldTypeIcon = ({ type, size = 14 }) => {
    const sx = { fontSize: size, color: "text.secondary" };
    if (type === "number") return <Percent sx={sx} />;
    if (type === "text") return <TextFields sx={sx} />;
    if (type === "date") return <CalendarToday sx={sx} />;
    return <Tag sx={sx} />;
};

export default FieldTypeIcon;
